
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { PricingSection } from "@/sections/PricingSection";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

const PdfToPsd = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <>
      <Head
        pageNamespace="page/PDFToPSD"
        ogImage="/images/pdf2psd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PDFToPSD:title")}
        subtitle={t("page/PDFToPSD:subtitle")}
        magicianLogoFile="psd"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled={!isFeatureEnabled("DISPLAY_PDF_CONVERTERS")} />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PDFToPSD:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/pdf-to-psd-example.png",
          alt: "PDF to Photoshop converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t("page/PDFToPSD:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PDFToPSD:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-pdf-into-psd.png",
          alt: t("page/PDFToPSD:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PDFToPSD:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PDFToPSD:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PDFToPSD:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PDFToPSD:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PDFToPSD:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/PDFToPSD:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/PDFToPSD:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />

      <CustomersLogosSection />
      <CTASection title={t("section/cta:titles.pdfToPsdPage")} href="#upload" />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PdfToPsd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/pdf-to-psd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  